import {find, findID, listener} from "../../../../../modules/vegas/js/util";
import VGCatalogOrder from "./order";

function onReady() {
	let formOrder = findID('form-cart');

	if (!formOrder) return false;

	formOrder.onkeydown = function (event) {
		return event.key !== "Enter";
	}
}

listener('submit', '#form-cart', (form, e) => {
	let cartPreload = find('.catalog-cart--preload');

	cartPreload?.classList.add('show');

	new VGCatalogOrder().make(form, function (data) {
		if (data.error) {
			cartPreload?.classList.remove('show');
			alert(data.msg);
		} else {
			location.href = data.redirect_to;
		}
	});
}, true);

listener('keydown change', '#form-cart [name=user_comment]', (el, e) => {
	let value = String(el.value);
	let max = parseInt(el.getAttribute('maxlength'));
	let left = max - value.length;

	if (left < 0) {
		left = 0;
		e.preventDefault();
	}

	let counterElement = el.closest('.comment-area').querySelector('.len-counter');
	counterElement.classList.toggle('text-danger', left === 0);

	let counterElementCount = counterElement.querySelector('.cnt');
	counterElementCount.innerText = left;
});


document.addEventListener('DOMContentLoaded', onReady);
